import {
  APIBlobResponse,
  PaginatedAPIResponse,
} from "../models/NetworkResponse";
import { VGBrand } from "../models/Vouchers/VGBrand";
import { VGVoucherStock } from "../models/Vouchers/VGVoucherStock";
import { PullVoucherRequest, Voucher } from "../models/Vouchers/Voucher";
import { VoucherAPIFilters } from "../models/Vouchers/VoucherFilters";
import { downloadFile, getAPI } from "./Networking";

export default class VouchersAPI {
  getQueryParams = (filters: VoucherAPIFilters): URLSearchParams => {
    const queryParams = new URLSearchParams();
    if (filters.page_no)
      queryParams.append("page_no", filters.page_no.toString());
    if (filters.limit) queryParams.append("limit", filters.limit.toString());
    if (filters.sort_by) queryParams.append("sort_by", filters.sort_by);
    if (filters.sort_type) queryParams.append("sort_type", filters.sort_type);

    if (filters.search_text)
      queryParams.append("search_text", filters.search_text);
    if (filters.order_id)
      queryParams.append("order_id", filters.order_id.join(","));
    if (filters.customer_id)
      queryParams.append("customer_id", filters.customer_id.join(","));
    return queryParams;
  };

  getVouchers = async (
    filters: VoucherAPIFilters
  ): Promise<PaginatedAPIResponse<Voucher>> => {
    try {
      const queryParams = this.getQueryParams(filters);
      const response = await getAPI(`/v5/vouchers?${queryParams.toString()}`);
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  downloadVouchers = async (
    filters: VoucherAPIFilters
  ): Promise<APIBlobResponse> => {
    try {
      const queryParams = this.getQueryParams(filters);
      const response = await downloadFile(
        `/v5/vouchers/download?${queryParams.toString()}`
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  getBrandDetailsByProductId = async (product_id: number): Promise<VGBrand> => {
    try {
      const response = await getAPI(
        `/v5/vouchers/brands/product/${product_id}`
      );
      return response.result as VGBrand;
    } catch (error) {
      throw error;
    }
  };

  getVoucherStockByProductIdAndDenomination = async (
    brand_code: string,
    denomination: string
  ): Promise<VGVoucherStock> => {
    const response = await getAPI(
      `/v5/vouchers/stocks?brand_code=${brand_code}&denomination=${denomination}`
    );
    return response.result as VGVoucherStock;
  };

  purchaseVoucher = async (
    product_id: number,
    brand_code: string,
    pr_id: number,
    quantity: number,
    denomination: string
  ) => {
    const response = await getAPI(
      `/v5/vouchers/pull-voucher?product_id=${product_id}&brand_code=${brand_code}&pr_id=${pr_id}&quantity=${quantity}&denomination=${denomination}`
    );
    return response;
  };

  syncAllBrands = async () => {
    const response = await getAPI(`/v5/vouchers/brands`);
    return response;
  };

  getPullVouchersRequests = async (): Promise<
    PaginatedAPIResponse<PullVoucherRequest>
  > => {
    const response = await getAPI(`/v5/vouchers/requests`);
    return response.result;
  };

  checkPullVoucherRequestStatus = async (id: number, requestId: string) => {
    const response = await getAPI(
      `/v5/vouchers/pull-voucher/status?order_id=${requestId}-${id}`
    );
    return response;
  };
}
